import React from 'react';
import { Button } from 'reactstrap';
import './IButton.scss';

const IButtonComponent = ({
  actionOnClick,
  label,
  type,
  className = 'button-filter',
  iconPlace = "left",
  btnIcon,
  disabled,
}: any) => {
  return (
    <div>
      <Button
        disabled={disabled}
        type={type}
        onClick={() => actionOnClick()}
        className={className}
      >
        {iconPlace !== "left" ?
          (
            <>
              {label}
              <i className={'iconForButton ' + btnIcon}></i>
            </>

          ) : (
            <>
              <i className={'iconForButton ' + btnIcon}></i>
              {label}
            </>
          )
        }
      </Button>
    </div>
  );
};

export default IButtonComponent;
